import { render, staticRenderFns } from "./Q10.vue?vue&type=template&id=d91a73fe&"
import script from "./Q10.vue?vue&type=script&lang=js&"
export * from "./Q10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports